import { Navigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceGoalsPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import Goals from 'modules/goals/components'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'

const GoalsPage = () => {
  const { data, loading } = useQuery(PerformanceGoalsPageDocument)

  const { navigation } = useNavigation()
  const { performanceFeatureAvailability } = usePerformanceModuleContext()
  const hasGoals = performanceFeatureAvailability.canSeeGoals

  if (!hasGoals && data?.apiCore._policies.accessGoalsConfigCreate.can)
    return <Navigate replace to={navigation.appStore.fullPath()} />

  return (
    <ResponsivePage.Body error={null} loading={loading} authorized={hasGoals} showHeader={false}>
      <Box gap="s32">
        <Goals />
      </Box>
    </ResponsivePage.Body>
  )
}

export default GoalsPage
